import React from 'react';
import { withStyles } from '@material-ui/core/styles';


//drop down field
import MenuItem from 'material-ui/MenuItem';
import { ValidatorForm,SelectValidator } from 'react-material-ui-form-validator';

import Button from '@material-ui/core/Button';

//API Gateway
import {API} from "aws-amplify";

const styles = theme => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 500,
  },
});

class OrganizationSelect extends React.Component {
  state = {
    organizations:[],
    organization:''

  };

    //Make GET request to get the list of organization
    async componentDidMount() {
  
        try {

          const organizations =await this.getOrganization();
          this.setState({ organizations });

        } catch (e) {
          alert(e);
        }
      
        this.setState({ submitted: false });
      }
     // make call to API to get organization for dropdown list

      getOrganization() {
        return API.get("organization", "/organization");
      }


  // Topics Dropdown Menu change
  handleOrganizationFieldChange = (event, index, organization) => 
  {
      this.setState({organization});
      var organizationName = organization;

      this.props.onChange(organizationName);
  }

  selectionRenderer = (organizations) => {
    switch (organizations.length) {
      case 0:
        return '';
      case 1:
        return organizations;
      default:
        return organizations;
    }
  }

  menuItems(organizations) {
    return organizations.map((o) => (
      <MenuItem
        key={o.name}
        insetChildren={true}
        checked={this.state.organizations.indexOf(o.name) > -1}
        value={o.name}
        primaryText={o.name}
      />
    ));
  }

  reset(event) {
    this.setState({  
      organization:''

  });
  this.props.onChange('');  

  };
  render() {

    return (
      <div>

        <ValidatorForm
                ref="form"
                onSubmit={this.handleOrganizationFieldChange}

            >            
             <SelectValidator
                  floatingLabelText="Organization"
                  name= "organization"
                  autoWidth={true}
                  value={this.state.organization}
                  onChange={this.handleOrganizationFieldChange}
                  selectionRenderer={this.selectionRenderer}
                  
                >
                  {this.menuItems(this.state.organizations.sort((a, b) => (a.organization < b.organization ? -1 : 1)))}
                </SelectValidator><br />
        </ValidatorForm>
        <Button  size="large" color="primary" onClick={ this.reset.bind(this)} style={{marginLeft:80, marginTop:125}}>
          Reset
        </Button>
      </div>
    );
  }
}



export default withStyles(styles)(OrganizationSelect);